export enum SupportedGroupType {
  VALUE_BASED = "VALUE_BASED",
  DATE_BUCKET = "DATE_BUCKET",
  NUMERIC_BUCKET = "NUMERIC_BUCKET",
  TAG_BASED = "TAG_BASED",
}

export enum BucketType {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
  WIDTH = "WIDTH",
  AUTO_WIDTH = "AUTO_WIDTH",
  TAGS_FULL = "TAGS_FULL",
  TAGS_FILTERED = "TAGS_FILTERED",
}

export const dateBucketTypes = [
  BucketType.DAY,
  BucketType.WEEK,
  BucketType.MONTH,
  BucketType.YEAR,
] as const;

export enum SupportedOperator {
  IN = "IN",
  NOT_IN = "NOT_IN",
  ALL = "ALL",
  NOT_NULL = "NOT_NULL",
  NULL = "NULL",
}

// Legacy exports for backward compatibility
export const supportedGroupTypeConstant = SupportedGroupType;
export const bucketTypeConstant = BucketType;
export const supportedOperatorConstant = SupportedOperator;
